// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type { AppOptions, EnvironmentType, UAParserResult } from '@seedplanner/shared-utils';
import * as React from 'react';

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const AppContext = React.createContext<AppContextType>(undefined as any);

export const AppContextProvider = AppContext.Provider;

export const useAppContext = (): AppContextType => {
  return React.useContext(AppContext);
};

export const useAppOptions = (): AppOptions => {
  return useAppContext().options;
};

export interface AppContextType {
  readonly css: ReadonlyArray<string>;
  readonly environment: EnvironmentType;
  readonly nonce: string | undefined;
  readonly options: AppOptions;
  readonly userAgent: UAParserResult;
  readonly enableSubscriptionEnforcement: boolean;
}
